module.exports = __webpack_public_path__ + "img/list.7b76ef36.png";